import clsx from 'clsx';
import type { IProduct } from '@recargas-dominicanas/core/types';
import { Image } from '@recargas-dominicanas/core/components';
import { style } from './product-card-info.module.css';

interface Props {
  product: IProduct;
  enabledTransition?: boolean;
}

export function ProductCardInfo(props: Props) {

  const { product, enabledTransition } = props;

  return (
    <div className={style.container}>
      {enabledTransition
        ? <div className={style.imageTransition}/>
        : <Image className={style.image} src={product.image}/>
      }
      <div className={clsx(style.title, enabledTransition && style.titleTransition)}>
        {product.name}
      </div>
    </div>
  );
}
